// Feature flags — set to false to hide a section site-wide (nav + page)
export const KULTOUR_ENABLED = false;
